function requiredFieldMessageDirective(){
	return{
		scope: {
			validate:'<?',
			message : '@',
			hideicon:'@'
		},
		restrict: 'E',
		replace : true,
		templateUrl: function(elem, attr) {
			return 'views/directives/requiredFieldMessageDirective.html';
		}
	};
};

module.directive('requiredFieldMessage', [ requiredFieldMessageDirective ]);